import { Intercom } from 'react-live-chat-loader';

export const IntercomBtn = () => {
    return (
        <Intercom />
    )
};
